/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdditionalCostType } from '../models/AdditionalCostType';
import type { AdditionalCostTypeRequest } from '../models/AdditionalCostTypeRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdditionalCostTypeRestEndpointService {
    /**
     * @returns AdditionalCostType OK
     * @throws ApiError
     */
    public static dashboardUpdateAdditionalCostType({
        typeId,
        requestBody,
    }: {
        typeId: number,
        requestBody: AdditionalCostTypeRequest,
    }): CancelablePromise<AdditionalCostType> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/accounting/additional-cost-types/{typeId}',
            path: {
                'typeId': typeId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static dashboardDeleteAdditionalCostType({
        typeId,
    }: {
        typeId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dashboard/api/v1/accounting/additional-cost-types/{typeId}',
            path: {
                'typeId': typeId,
            },
        });
    }
    /**
     * @returns AdditionalCostType OK
     * @throws ApiError
     */
    public static dashboardGetAdditionalCostTypes(): CancelablePromise<Array<AdditionalCostType>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/accounting/additional-cost-types',
        });
    }
    /**
     * @returns AdditionalCostType OK
     * @throws ApiError
     */
    public static dashboardCreateAdditionalCostType({
        requestBody,
    }: {
        requestBody: AdditionalCostTypeRequest,
    }): CancelablePromise<AdditionalCostType> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/accounting/additional-cost-types',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
